import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../../../../shared/ui/Button';
import { usePaymentReturn } from '../../model/use-payment-return';
import { useAppSelector } from '../../../../app/store';
import { UserSubscriptionInfo } from './user-info';

export function PaymentReturnStatus() {
    const { phase, message, retry } = usePaymentReturn();
    const location = useLocation();
    if (phase === 'idle') return null;
    const pending = phase === 'checking' || phase === 'waiting';
    return <section aria-label="Результат оплаты" aria-busy={pending}>
        <p role="status" aria-live="polite">{message}</p>
        {['timeout', 'error', 'review'].includes(phase)
            && <Button title="Проверить ещё раз" onClickFunc={retry} />}
        {phase === 'loginRequired' && <Link to="/login" state={{ subscriptionReturn: `${location.pathname}${location.search}` }}>Войти</Link>}
    </section>;
}

export function SubscriptionPaymentReturnPage() {
    const { isAuth } = useAppSelector((state) => state.userAuthSettings);
    const location = useLocation();
    return (
        <>
            <h1>Подписка</h1>
            <PaymentReturnStatus />
            {isAuth && <UserSubscriptionInfo />}
            {!isAuth && !location.search && <Link to="/login" state={{ subscriptionReturn: '/subscription' }}>Войти в аккаунт</Link>}
        </>
    )
}
